import formatDate from '~/helpers/formatDate';
import useTranslation from '~/hooks/useTranslation';
import participantStyles from '~/styles/myEnvironment/participant.module.css';
import utilStyles from '~/styles/utils.module.css';
import ParticipantAddress from './ParticipantAddress';

export type ParticipantAddressType = {
  street: string;
  housenum?: string | null;
  addressLine2?: string | null;
  city: string;
  state?: string | null;
  postalCode: string;
  country: string;
};

type Props = {
  className?: string;
  title: string;
  firstName: string;
  lastName: string;
  gender?: string | null;
  birthDate?: string | null;
  email?: string | null;
  phone?: string | null;
  address?: ParticipantAddressType;
};

export default function Participant({
  className,
  title,
  firstName,
  lastName,
  gender,
  birthDate,
  email,
  phone,
  address,
}: Props) {
  const translate = useTranslation();

  return (
    <div className={className}>
      <h3 className={participantStyles.participantTitle}>
        {title}
      </h3>

      <p>
        {`${firstName} ${lastName}`}
      </p>

      {gender && (
        <p>
          {`${translate('form.gender')}: ${gender}`}
        </p>
      )}

      {birthDate && (
        <p>
          {`${translate('form.birth_date')}: ${formatDate(birthDate, 'd-m-Y')}`}
        </p>
      )}

      {email && (
        <p>
          {`${translate('form.email')}: ${email}`}
        </p>
      )}

      {phone && (
        <p>
          {`${translate('form.phone')}: ${phone}`}
        </p>
      )}

      {address && (
        <ParticipantAddress
          className={utilStyles.mtMedium}
          address={address}
        />
      )}
    </div>
  );
}
